/* eslint-disable max-len */
// istanbul ignore file

enum EntryMethodPreferenceOption {
    NO = 0,
    YES = 1,
    BY_EXCEPTION = 2
}

enum EntryMethodPreference {
    occupantAppointmentPreference = 'occupantAppointmentPreference',
    occupantSingleKeyPreference = 'occupantSingleKeyPreference',
    internalEnPreference = 'internalEnPreference',
    vacantEntryPreference = 'vacantEntryPreference'
}

enum EntryMethodPreferenceExpiresAt {
    occupantAppointmentPreferenceExpiresAt = 'occupantAppointmentPreferenceExpiresAt',
    occupantSingleKeyPreferenceExpiresAt = 'occupantSingleKeyPreferenceExpiresAt',
    internalEnPreferenceExpiresAt = 'internalEnPreferenceExpiresAt',
    vacantEntryPreferenceExpiresAt = 'vacantEntryPreferenceExpiresAt'
}

type TempEntryMethodPreference = EntryMethodPreference | EntryMethodPreferenceExpiresAt;

type EntryMethodPreferencesPayload = {
    preferences: { [key in EntryMethodPreference]?: EntryMethodPreferenceOption | number | null };
    tempPreferences?: {
        [key in TempEntryMethodPreference]?: EntryMethodPreferenceOption | number | null;
    };
};

type EntryMethodPreferenceSettings = EntryMethodPreferencesPayload & {
    tempExpireDateSettings: {
        min: string;
        max: string;
    };
} | null;

enum EntryMethodField {
    Appointment = EntryMethodPreference.occupantAppointmentPreference,
    EntryNotification = EntryMethodPreference.internalEnPreference
}

export {
    EntryMethodPreferenceOption,
    EntryMethodPreference,
    TempEntryMethodPreference,
    EntryMethodPreferenceSettings,
    EntryMethodPreferencesPayload,
    EntryMethodField,
};
